import lessvars from './modules/lessvars';

const theme = window.HIVE_ADMIN_THEME = {
  less: lessvars,
};

export default theme;
